module.exports = __webpack_public_path__ + "img/numero-telephone.b44a5bf0.svg";